import React from 'react';
import { Dropdown } from 'antd';
import { GlobalOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

// سوییچر زبان مخصوص پنل مدیریت. مستقل از تشخیص زبان بر اساس دامنه/ساب‌دامنه
// (که مخصوص سایت عمومی است) عمل می‌کند: انتخاب ادمین در localStorage همان
// کلید 'language' ذخیره می‌شود و بلافاصله رابط پنل مدیریت را عوض می‌کند.
const LANGUAGE_LABELS = {
  fa: 'فارسی',
  en: 'English',
  de: 'Deutsch',
  es: 'Español',
  fr: 'Français',
  it: 'Italiano',
  ja: '日本語',
  ko: '한국어',
  pt: 'Português',
  hi: 'हिन्दी',
  zh: '中文',
};

export default function AdminLanguageSwitcher() {
  const { i18n } = useTranslation();
  const currentLang = i18n.language || 'fa';

  const changeLanguage = (lang) => {
    localStorage.setItem('language', lang);
    i18n.changeLanguage(lang);
  };

  const items = Object.keys(LANGUAGE_LABELS).map((code) => ({
    key: code,
    label: LANGUAGE_LABELS[code],
    onClick: () => changeLanguage(code),
  }));

  return (
    <Dropdown
      menu={{ items, selectedKeys: [currentLang] }}
      placement="bottomRight"
      trigger={['click']}
    >
      <span
        style={{
          cursor: 'pointer',
          display: 'inline-flex',
          alignItems: 'center',
          gap: 4,
          padding: '0 8px',
          color: '#1a1a2e',
        }}
      >
        <GlobalOutlined />
        {LANGUAGE_LABELS[currentLang] || currentLang}
      </span>
    </Dropdown>
  );
}
